import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

const DropDownParam = ({
    label,
    name,
    value,
    options,
    handleDropDownChange,
    width=false,
    className=''
}) => {

  return (
    <FormControl 
        sx={{ width: { xs: '100%', sm:width === false ? '30%':'100%',  md:width === false ? '24%':'100%'}}} 
        //fullWidth
        margin="dense"
        className={className}
    >
        <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            sx={{ "&:focus": {
                backgroundColor: "#ffffff"
                } 
            }}
            label={label} 
            value={value?.toString()}
            onChange={handleDropDownChange}
            name={name}
        >
            <MenuItem value="">Select {label}</MenuItem>
            { options?.map((option) => (
                <MenuItem data-value={option?.data_value} key={option.value} value={option.value}>{option.name}</MenuItem>
            ))}
        </Select>
    </FormControl>
  )
}

export default DropDownParam